import fillStarIcon from "../../../assets/images/icons/star-fill.svg";
import emptyStarIcon from "../../../assets/images/icons/star-empty.svg";

import styles from "./styles.module.scss";

type Props = {
  rating?: number;
  from?: number;
  size?: number;
};

const RatingBar = ({ rating = 0, from = 5, size = 20 }: Props) => {
  const fillStar = (
    <img
      src={fillStarIcon}
      style={{
        width: `${size}px`,
        height: `${size}px`,
      }}
      alt=""
    />
  );
  const emptyStar = (
    <img
      src={emptyStarIcon}
      style={{
        width: `${size}px`,
        height: `${size}px`,
      }}
      alt=""
    />
  );

  const fillRatingResult = Array(rating).fill(fillStar);
  const emptyRatingResult = Array(from - rating).fill(emptyStar);
  const result = [...fillRatingResult, ...emptyRatingResult];

  return (
    <div className={styles.stars}>
      {result.map((star, index) => (
        <span key={index}>{star}</span>
      ))}
    </div>
  );
};


export default RatingBar;
